import { Tag, Card, DatePicker, Input, Select, Table } from "antd";
import network from "network/network";
import React, { useEffect, useState } from "react";
import localeEN from 'antd/es/date-picker/locale/en_GB';
import localeTR from 'antd/es/date-picker/locale/tr_TR';
import moment from 'moment';
import 'moment/locale/tr';
import 'moment/locale/en-gb';


import tools from 'tools'
import { useTranslation } from "react-i18next";
import ReusableButton from "components/Elements/ReusableButton";
import { ExportOutlined } from "@ant-design/icons";

import * as XLSX from 'xlsx';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBranchList } from "utils/redux/actions/branchAction";

const { RangePicker } = DatePicker;

const StampReport = (props) => {

    const { i18n, t } = useTranslation();
    const [stampData, setStampData] = useState([]);
    const [selectedDates, setSelectedDates] = useState(null);
    const [searchterm, setSearchTerm] = useState();
    const [SelectedBranch, setSelectedBranch] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState(0);
    const currentLang = i18n.language;

    const dateLocale = currentLang === "tr" ? localeTR : localeEN;
    const dateFormat = currentLang === "tr" ? 'DD.MM.YYYY' : 'MM/DD/YYYY';

    moment.locale(currentLang === 'tr' ? 'tr' : 'en-gb');

    const { branchList } = props;

    useEffect(() => {
        selectStampData();

        var params = {}
        props.selectBranchListAction(params);
    }, []);

    const selectStampData = async () => {
        var params = {}
        const result = await network.get("/admin/Stamp/GetAllStamps", params, false);

        const { data } = result.data;

        setStampData(data);
    }

    const filteredData = stampData.filter(item => {
        if (selectedDates || searchterm || selectedStatus || SelectedBranch) {
            const itemDate = moment(item.stampdate);

            const isDateValid = selectedDates?.length === 2
                ? itemDate >= selectedDates[0]?.startOf('day') && itemDate <= selectedDates[1]?.endOf('day')
                : true;


            const normalizeText = (text) =>
                text.toLocaleLowerCase('tr').normalize('NFKC');

            const isSearch = searchterm
                ? Object.values(item).some(value =>
                    normalizeText(String(value)).includes(normalizeText(searchterm))
                )
                : true;

            const isBranchValid = SelectedBranch ? item.branchid === SelectedBranch : true;

            const isStatus = () => {
                if (selectedStatus) {
                    if (selectedStatus == 4) {
                        return item.islaststamp == true;
                    } else {
                        return item.status == selectedStatus;
                    }
                }
                return true;
            }

            return isDateValid && isSearch && isStatus() && isBranchValid;
        } else {
            return stampData;
        }
    })


    const handleExcelExport = () => {
        const excelData = filteredData.map((record) => ({
            [t("clientName")]: record.clientname,
            [t("clientNumber")]: record.clientnumber,
            [t("stampDate")]: new Date(record.stampdate).toLocaleDateString(),
            [t("stampStatus")]: record.status == 3 ? t("cancelled") :
                record.status == 1 ? t("pending") :
                    record.islaststamp ? t("gift") : t("approved"),
            [t("productCode")]: record.productcode,
            [t("productName")]: record.productname,
            [t("giftCode")]: record.giftcode,
            [t("branch")]: record.branchname,
        }));

        // Create a new worksheet and add the data
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Stamps");

        // Export to Excel
        XLSX.writeFile(workbook, "StampData.xlsx");
    };

    function checkProcessStatus(item) {
        if (item.status == 3) {
            return (
                <div>
                    <Tag color="red">{t("cancelled")}</Tag>
                </div>
            );
        } else if (item.status == 1) {
            return (
                <div>
                    <Tag color="orange">{t("pending")}</Tag>
                </div>
            );
        } else if (item.islaststamp == true) {
            return (
                <div>
                    <Tag color="purple">{t("gift")}</Tag>
                </div>
            );
        } else if (item.islaststamp == false) {
            return (
                <div>
                    <Tag color="green">{t("approved")}</Tag>
                </div>
            );
        }
        return null;
    }

    const tableColumn = [
        {
            title: t("clientName"),
            dataIndex: "clientname",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "clientname"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>{record.clientname}</div>
            ),
        },
        {
            title: t("clientNumber"),
            dataIndex: "clientnumber",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "clientnumber"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>{record.clientnumber}</div>
            ),
        },
        {
            title: t("stampDate"),
            dataIndex: "stampdate",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "stampdate"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {moment(record.stampdate).format(
                        currentLang === "tr" ? "DD.MM.YYYY HH:mm" : "MM/DD/YYYY hh:mm A"
                    )}
                </div>
            ),
        },
        {
            title: t("stampStatus"),
            dataIndex: "status",
            align: "center",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>{checkProcessStatus(record)}</div>
            ),
        },
        {
            title: t("productCode"),
            dataIndex: "productcode",
            align: "center",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {record.productcode == null ? "-" : record.productcode}
                </div>
            ),
        },
        {
            title: t("productName"),
            dataIndex: "productname",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "productname"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {record.productname == null ? "-" : record.productname}
                </div>
            ),
        },
        {
            title: t("giftCode"),
            dataIndex: "giftcode",
            align: "center",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {record.giftcode == null ? "-" : record.giftcode}
                </div>
            ),
        },
        {
            title: t("branch"),
            dataIndex: "branchname",
            align: "center",
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>{record.branchname}</div>
            ),
        },
    ];

    return (
        <>

            <Card title={t("stampReport")}>
                <div className="mb-1" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div className="mb-2" style={{ display: "flex", alignItems: "center", gap: "15px" }}>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("dateRange")}
                            </label>
                            <RangePicker
                                onChange={(dates) => setSelectedDates(dates)}
                                style={{ width: "100%", maxWidth: "300px" }}
                                format={dateFormat}
                                locale={dateLocale}
                                placeholder={[t("startDate"), t("endDate")]}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("stampStatus")}
                            </label>
                            <Select
                                options={[
                                    { value: 0, label: t("all") },
                                    { value: 2, label: t("approved") },
                                    { value: 1, label: t("pending") },
                                    { value: 3, label: t("canceled") },
                                    { value: 4, label: t("gift") },
                                ]}
                                style={{ width: "200px" }}
                                onChange={(value) => setSelectedStatus(value)}
                                placeholder={t("selectStampStatus")}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("branchSelection")}
                            </label>
                            <Select
                                style={{ width: "150px" }}
                                placeholder={t("selectBranch")}
                                options={[
                                    { value: 0, label: t("all") },
                                    ...branchList.map(item => ({
                                        value: item.branchid,
                                        label: item.branchname
                                    }))
                                ]}
                                onChange={(value) => setSelectedBranch(value)}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("search")}
                            </label>
                            <Input
                                placeholder={t("searchPlaceholder")}
                                value={searchterm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ width: "200px" }}
                            />
                        </div>
                    </div>

                    <div>
                        <ReusableButton
                            variant={"template"}
                            text={t("exportToExcel")}
                            icon={<ExportOutlined />}
                            onClick={() => handleExcelExport()}
                        />
                    </div>
                </div>

                <Table
                    key={stampData.length}
                    columns={tableColumn}
                    dataSource={[...filteredData].reverse()}
                    pagination={{
                        total: filteredData.length,
                        showTotal: (total) => `${t("total")}: ${total}`
                    }}
                />
            </Card>

        </>
    )
}

function mapStateToProps(state) {

    return {
        branchList: state.branchReducer.branchList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        selectBranchListAction: bindActionCreators(selectBranchList, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StampReport);
